import React from 'react'
import { useHistory } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import { useQueryStringParameters } from '../../lib/query-string'
import Redirect from '../../components/redirect'
import PageHeading from '../../components/page-heading'
import ConfirmAccountForm from '../../components/confirm-account-form'

const ConfirmAccountPage = () => {
  const { username, code } = useQueryStringParameters()
  const history = useHistory()

  const onConfirmAccountFormSuccess = () => {
    history.push('/confirm-account/success')
  }

  if (!username) {
    return <Redirect to="/" />
  }

  return (
    <Box mb={5}>
      <PageHeading
        heading="MyPGA Account Verification"
        subheading={`We have sent an account verification code to ${username}. Enter it below to confirm your account.`}
      />
      <ConfirmAccountForm username={username} code ={code} onSuccess={onConfirmAccountFormSuccess} />
    </Box>
  )
}

export default ConfirmAccountPage
